export interface JobKodawariType {
  value: string;
  text: string;
}

export interface JobKodawariCountType {
  value: string;
  text: string;
  count: number;
}

export const KODAWARI = {
  // 雇用形態
  employmentStatus: [
    {
      value: '1',
      text: '正社員',
    },
    {
      value: '2',
      text: '契約社員',
    },
    {
      value: '3',
      text: 'その他（FCオーナー・業務委託など）',
    },
  ],
  // 休日・働き方
  holidayAndWayOfWorking: [
    {
      value: '1',
      text: '完全週休2日制',
    },
    {
      value: '2',
      text: '年間休日120日以上',
    },
    {
      value: '3',
      text: '土日祝休み',
    },
    {
      value: '4',
      text: '5日以上の連続休暇OK',
    },
    {
      value: '5',
      text: '原則定時退社',
    },
    {
      value: '6',
      text: '残業20時間未満',
    },
    {
      value: '7',
      text: 'フレックス勤務',
    },
    {
      value: '8',
      text: '産休・育休取得実績あり',
    },
  ],
  // 募集・採用情報
  requirements: [
    {
      value: '1',
      text: '職種未経験歓迎',
    },
    {
      value: '2',
      text: '業種未経験歓迎',
    },
    {
      value: '3',
      text: '学歴不問',
    },
    {
      value: '4',
      text: '転勤なし（勤務地限定）',
    },
    {
      value: '5',
      text: '第二新卒歓迎',
    },
    {
      value: '6',
      text: '社会人経験10年以上歓迎',
    },
    {
      value: '7',
      text: '急募！入社まで1カ月',
    },
    {
      value: '8',
      text: '採用人数5名以上',
    },
    {
      value: '9',
      text: '入社後の職種変更なし',
    },
  ],
  // 会社・職場の環境
  workplaceEnvironment: [
    {
      value: '1',
      text: '上場企業',
    },
    {
      value: '2',
      text: '外資系企業',
    },
    {
      value: '3',
      text: '定着率95％以上',
    },
    {
      value: '4',
      text: '女性活躍',
    },
    {
      value: '5',
      text: '自動車通勤OK',
    },
    {
      value: '6',
      text: '服装自由',
    },
  ],
  // 待遇・福利厚生
  welfareBenefits: [
    {
      value: '1',
      text: '退職金制度',
    },
    {
      value: '2',
      text: '社宅・家賃補助制度',
    },
    {
      value: '3',
      text: '育児・託児支援制度',
    },
    {
      value: '4',
      text: '資格取得支援制度',
    },
    {
      value: '5',
      text: '研修制度充実',
    },
    {
      value: '6',
      text: '固定給25万円以上',
    },
    {
      value: '7',
      text: '固定給35万円以上',
    },
    {
      value: '8',
      text: 'U・Iターン支援あり',
    },
  ],
  // 語学
  languageSkills: [
    {
      value: '1',
      text: '英語を活かす',
    },
    {
      value: '2',
      text: '中国語を活かす',
    },
  ],
  // 仕事内容
  positions: [
    {
      value: '1',
      text: '海外出張あり',
    },
    {
      value: '2',
      text: '管理職・マネジャー',
    },
  ],
  // 社員の平均年齢
  employeeAverageAge: [
    {
      value: '1',
      text: '20代',
    },
    {
      value: '2',
      text: '30代',
    },
    {
      value: '3',
      text: '40代',
    },
    {
      value: '4',
      text: '50代以上',
    },
  ],
  // 設立
  establish: [
    {
      value: '1',
      text: '～1年',
    },
    {
      value: '2',
      text: '2～10年',
    },
    {
      value: '3',
      text: '11～50年',
    },
    {
      value: '4',
      text: '51年～',
    },
  ],
};

export const KODAWARI_MAP = {
  employmentStatus: new Map(
    KODAWARI.employmentStatus.map(({ value, text }) => [value, text])
  ),
  requirements: new Map(
    KODAWARI.requirements.map(({ value, text }) => [value, text])
  ),
  workplaceEnvironment: new Map(
    KODAWARI.workplaceEnvironment.map(({ value, text }) => [value, text])
  ),
  holidayAndWayOfWorking: new Map(
    KODAWARI.holidayAndWayOfWorking.map(({ value, text }) => [value, text])
  ),
  welfareBenefits: new Map(
    KODAWARI.welfareBenefits.map(({ value, text }) => [value, text])
  ),
  languageSkills: new Map(
    KODAWARI.languageSkills.map(({ value, text }) => [value, text])
  ),
  positions: new Map(
    KODAWARI.positions.map(({ value, text }) => [value, text])
  ),
  employeeAverageAge: new Map(
    KODAWARI.employeeAverageAge.map(({ value, text }) => [value, text])
  ),
  establish: new Map(
    KODAWARI.establish.map(({ value, text }) => [value, text])
  ),
};

export type KodawariType = keyof typeof KODAWARI;
